let _originalAvailabilities = null;
let _queryFilter = {};

function intersection(lists) {
  var result = [];
  for (var i = 0; i < lists.length; i++) {
    var currentList = lists[i];
    for (var y = 0; y < currentList.length; y++) {
      var currentValue = currentList[y];
      if (result.indexOf(currentValue) === -1) {
        if (lists.filter(function (obj) {
            return obj.indexOf(currentValue) == -1
          }).length == 0) {
          result.push(currentValue);
        }
      }
    }
  }
  return result;
}

class AvailabilityFilter {
  constructor() {}

  populate(items) {
    const result = {
      classes: [],
      specs: [],
      brands: [],
      sort: []
    };

    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.className) {
          const classType = result.classes.find(
            (x) => x.value === item.className.toLowerCase()
          );
          if (classType) {
            classType.count += 1;
          } else {
            result.classes.push({
              value: item.className.toLowerCase(),
              text: item.className,
              count: 1,
              isSelected: false,
              isEnable: true
            });
          }
        }

        if (item.feature) {
          if (item.feature.doors && item.feature.doors >= 4) {
            const doors = result.specs.find((x) => x.value === "4doors");
            if (doors) {
              doors.count += 1;
            } else {
              result.specs.push({
                value: "4doors",
                text: "4+ Doors",
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }

          if (item.feature.hasAirConditioning) {
            const airConditioning = result.specs.find(
              (x) => x.value === "airConditioning"
            );
            if (airConditioning) {
              airConditioning.count += 1;
            } else {
              result.specs.push({
                value: "airConditioning",
                text: "With Air Conditioning",
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }

          if (item.feature.largeBaggageCapacity) {
            const largeBaggage = result.specs.find(
              (x) => x.value === "largeBaggage"
            );
            if (largeBaggage) {
              largeBaggage.count += 1;
            } else {
              result.specs.push({
                value: "largeBaggage",
                text: "Large Baggage",
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }

          if (item.feature.smallBaggageCapacity) {
            const smallBaggage = result.specs.find(
              (x) => x.value === "smallBaggage"
            );
            if (smallBaggage) {
              smallBaggage.count += 1;
            } else {
              result.specs.push({
                value: "smallBaggage",
                text: "Small Baggage",
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }

          if (item.feature.transmission) {
            switch (item.feature.transmission.toLowerCase()) {
              case "at":
                const automaticTransmission = result.specs.find(
                  (x) => x.value === "automaticTransmission"
                );
                if (automaticTransmission) {
                  automaticTransmission.count += 1;
                } else {
                  result.specs.push({
                    value: "automaticTransmission",
                    text: "Automatic Transmission",
                    count: 1,
                    isSelected: false,
                    isEnable: true
                  });
                }
                break;
              case "mt":
                const manualTransmission = result.specs.find(
                  (x) => x.value === "manualTransmission"
                );
                if (manualTransmission) {
                  manualTransmission.count += 1;
                } else {
                  result.specs.push({
                    value: "manualTransmission",
                    text: "Manual Gearbox",
                    count: 1,
                    isSelected: false,
                    isEnable: true
                  });
                }
                break;
              case "autonomous":
                const autonomousCar = result.specs.find(
                  (x) => x.value === "autonomousCar"
                );
                if (autonomousCar) {
                  autonomousCar.count += 1;
                } else {
                  result.specs.push({
                    value: "autonomousCar",
                    text: "Autonomous Car",
                    count: 1,
                    isSelected: false,
                    isEnable: true
                  });
                }
                break;
            }
          }

          if (item.feature.paxCapacity && item.feature.paxCapacity >= 4) {
            const pax = result.specs.find((x) => x.value === "4pax");
            if (pax) {
              pax.count += 1;
            } else {
              result.specs.push({
                value: "4pax",
                text: "4+ Pax",
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }
        }

        if (item.factoryName) {
          const factoryAndBrand = `${item.factoryName ? item.factoryName : ''} ${item.brandName ? item.brandName : ''}`.trim();
          if (factoryAndBrand) {
            const brand = result.brands.find((x) => x.text === factoryAndBrand);
            if (brand) {
              brand.count += 1;
            } else {
              result.brands.push({
                value: factoryAndBrand.toLowerCase(),
                text: factoryAndBrand,
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }
        }
      }

      result.sort = [{
          text: "Lowest Rate",
          value: "lowestRate",
        },
        {
          text: "Highest Rate",
          value: "highestRate",
        },
      ];

      _originalAvailabilities = JSON.stringify(items);
      _queryFilter['classes'] = [];
      _queryFilter['specs'] = [];
      _queryFilter['brands'] = [];
    }

    return result;
  }

  applyFilter(query, filterType, sortType) {
    if (query.isSelected) {
      _queryFilter[filterType].push(query.value)
    } else {
      _queryFilter[filterType] = _queryFilter[filterType].filter(function (value) {
        return value !== query.value;
      });
    }

    let hasFilter = false;
    let unmergedIndex = -1;
    let unmergedResult = [];
    let tempUnmergedResult = [];

    const availabilities = JSON.parse(_originalAvailabilities);

    if (_queryFilter['classes'].length > 0) {
      hasFilter = true;
      unmergedIndex += 1;
      tempUnmergedResult = [];
      for (let i = 0; i < _queryFilter['classes'].length; i++) {
        tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.className.toLowerCase() === _queryFilter['classes'][i]));
      }
      unmergedResult[unmergedIndex] = tempUnmergedResult;
    }

    if (_queryFilter['specs'].length > 0) {
      hasFilter = true;
      unmergedIndex += 1;
      tempUnmergedResult = [];
      for (let i = 0; i < _queryFilter['specs'].length; i++) {
        const item = _queryFilter['specs'][i];
        switch (item) {
          case '4doors':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.doors && x.feature.doors >= 4));
            break;
          case 'airConditioning':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.hasAirConditioning));
            break;
          case 'largeBaggage':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.largeBaggageCapacity && x.feature.largeBaggageCapacity > 0));
            break;
          case 'smallBaggage':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.smallBaggageCapacity && x.feature.smallBaggageCapacity > 0));
            break;
          case 'automaticTransmission':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.transmission && x.feature.transmission === 'AT'));
            break;
          case 'manualTransmission':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.transmission && x.feature.transmission === 'MT'));
            break;
          case 'autonomousCar':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.transmission && x.feature.transmission === 'Autonomous'));
            break;
          case '4pax':
            tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => x.feature.paxCapacity && x.feature.paxCapacity >= 4));
            break;
        }
      }
      unmergedResult[unmergedIndex] = tempUnmergedResult;
    }

    if (_queryFilter['brands'].length > 0) {
      hasFilter = true;
      unmergedIndex += 1;
      tempUnmergedResult = [];
      for (let i = 0; i < _queryFilter['brands'].length; i++) {
        tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(x => `${x.factoryName ? x.factoryName : ''} ${x.brandName ? x.brandName : ''}`.trim().toLowerCase() === _queryFilter['brands'][i]));
      }
      unmergedResult[unmergedIndex] = tempUnmergedResult;
    }

    // if no filter is selected, then set back the result to default
    if (!hasFilter) {
      return this.applySort(availabilities, sortType);
    }

    // intersect multiple array
    const result = intersection(unmergedResult);

    // apply sort
    return this.applySort(result, sortType);
  }

  applySort(availabilities, sortType) {
    var result = [];
    switch (sortType) {
      case 'lowestRate':
        result = availabilities.sort(function (a, b) {
          let itemA = parseInt(a.totalFare);
          let itemB = parseInt(b.totalFare);
          if (itemA < itemB) return -1;
          if (itemA > itemB) return 1;
          return 0;
        });
        break;
      case 'highestRate':
        result = availabilities.sort(function (a, b) {
          let itemA = parseInt(a.totalFare);
          let itemB = parseInt(b.totalFare);
          if (itemA < itemB) return -1;
          if (itemA > itemB) return 1;
          return 0;
        }).reverse();
        break;
    }
    return result;
  }

  reset() {
    _queryFilter['classes'] = [];
    _queryFilter['specs'] = [];
    _queryFilter['brands'] = [];
    return JSON.parse(_originalAvailabilities);
  }
}

export default AvailabilityFilter;



// WEBPACK FOOTER //
// ./src/plugins/availabilityFilter.js